import { render, staticRenderFns } from "./swipeButton.vue?vue&type=template&id=148368cc&scoped=true"
import script from "./swipeButton.vue?vue&type=script&lang=js"
export * from "./swipeButton.vue?vue&type=script&lang=js"
import style0 from "./swipeButton.vue?vue&type=style&index=0&id=148368cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148368cc",
  null
  
)

export default component.exports